// @flow
import _ from 'lodash'
import { putRawAdvertisement, type RawAdvertisement } from '../AdvertisementDataAdapter'

type ToggleAction = {|
  type: 'COPIED_AD_LIST.TOGGLE',
  storeId: string
|}
type PutAdvertisementsAction = {|
  type: 'COPIED_AD_LIST.PUT_ADVERTISEMENTS',
  storeIds: Array<string>
|}

type Action = ToggleAction | PutAdvertisementsAction

type State = {|
  +disabledStoreIds: Array<string>,
  +storeIds: Array<string>
|}

export type { State }

const initialState: State = {
  disabledStoreIds: [],
  storeIds: []
}

export function toggle(storeId: string): ToggleAction {
  return {
    type: 'COPIED_AD_LIST.TOGGLE',
    storeId
  }
}

export function initAdvertisements(
  advertisements: Array<RawAdvertisement>
): PutAdvertisementsAction {
  return {
    type: 'COPIED_AD_LIST.PUT_ADVERTISEMENTS',
    storeIds: _.map(advertisements, (advertisement) => {
      return putRawAdvertisement(advertisement)
    })
  }
}

export default function copiedAdvertisementList(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'COPIED_AD_LIST.TOGGLE': {
      const storeId = action.storeId
      const disabledStoreIds = state.disabledStoreIds
      const modifiedDisabledStoreIds: Array<string> = _.includes(disabledStoreIds, storeId)
        ? _.without(disabledStoreIds, storeId)
        : _.concat(disabledStoreIds, storeId)
      return { ...state, disabledStoreIds: modifiedDisabledStoreIds }
    }
    case 'COPIED_AD_LIST.PUT_ADVERTISEMENTS': {
      const storeIds = action.storeIds
      return {
        ...state,
        storeIds
      }
    }
    default:
      return state
  }
}
